import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rt-progress',
  styleUrls: ['./progress.component.less'],
  templateUrl: './progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressComponent {
  @Input() public percents: number = 0;
  @Input() public height: number = 0.8;
  @Input() public isFullWidth: boolean = false;
  @Input() public background: string = '#89ccf2';
  @Input() public progressBarBorderRadius = true;
  @Input() public noProgressContainerTopBorderRadius = false;
  @Input() public noProgressContainerBottomBorderRadius = false;
  @Input() public noProgressBarBoxShadow = false;
}
